<template>
  <div>
    <el-card :body-style="cardBodyStyle">
      <el-form :model="query" label-position="right" label-width="80px" :inline="true">
        <el-form-item label="类型" class="no-show-error-message">
          <el-input v-model="query.type" size="small" placeholder="请输入查询条件" style="width :200px;"></el-input>
        </el-form-item>
        <el-form-item label="编码" class="no-show-error-message">
          <el-input v-model="query.code" size="small" placeholder="请输入查询条件" style="width :200px;"></el-input>
        </el-form-item>

        <el-form-item label="名称" class="no-show-error-message">
          <el-input v-model="query.name" size="small" placeholder="请输入查询条件" style="width :200px;"></el-input>
        </el-form-item>

        <el-form-item label="" class="no-show-error-message">
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button type="primary" plain size="small" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>

    </el-card>
    <el-card :body-style="cardBodyStyle">
      <el-table :data="tableData" stripe border style="width: 99%;">
        <el-table-column prop="dicType" label="类型代码" width="140" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="dicName" label="代码名称" width="140" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="dicCode" label="代码值" width="140" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="100" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>
        <el-table-column label="操作" width="200px"  header-align="center" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalRows">
      </el-pagination>
    </el-card>
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="操作" :visible.sync="dialogVisible" width="500px">
      <el-form :model="sysDic" label-position="right" label-width="80px">
        <el-form-item label="类型">
          <el-input v-model="sysDic.dicType" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="编码">
          <el-input v-model="sysDic.dicCode" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="sysDic.dicName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="sysDic.sort" placeholder=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleSave">保存</el-button>
          <el-button @click="handleCancelSave">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


  </div>
</template>
<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    data() {
      return {
        cardBodyStyle: tools.style.card,
        tableData: [],
        tableProperty: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        query: {
          name: '',
          code: '',
          type: '',
        },
        sysDic: {
          id: '',
          dicCode: '',
          dicName: '',
          dicType: '',
          sort: '',

        },
        loading: true,
        dialogVisible: false,
      }
    },
    methods: {
      //查询table数据
      getTableData() {
        var url = 'framework/SysDic/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          type: this.query.type,
          code: this.query.code,
          name: this.query.name,
        }
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            this.tableData = response.data.data.list
            this.totalRows = response.data.data.total
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
          this.loading = false
        });
      },
      //查询table列
      getTableProperty() {
        //console.log("获取table数据getTableData")
        var url = 'CodeMachine/queryTableProperty.do'
        var param = {
          businessName: 'SYS_DIC'
        }
        axios.get(url, param).then(response => {
          this.tableProperty = response.data.data
        });
      },

      // 修改每页行数
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      //新增按钮事件
      handleAdd() {
        this.dialogVisible = true
        this.sysDic = {
          id: '',
          dicCode: '',
          dicName: '',
          dicType: '',
          sort: '',
        }
      },
      // 编辑按钮事件
      handleEdit(row) {
        this.dialogVisible = true
        this.sysDic = row

      },
      // 删除按钮事件
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysDic/remove.do'
          var param = {
            id: id
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!' + response.data.msg
              });

            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //保存取消按钮事件   关闭编辑对话框
      handleCancelSave(row) {
        this.dialogVisible = false
      },
      //保存按钮事件
      handleSave(row) {
        var url = 'framework/SysDic/save.do'
        var json = JSON.stringify(this.sysDic)
        var param = {
          json: json
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        });
      },

      // 查询按钮事件
      search() {
        this.getTableData()
      }
    },
    mounted() {
      this.getTableData()
      // this.getTableProperty()
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/dic.vue